import React, { useContext } from 'react';
import { Form, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import { WidgetsContext } from '../../../GlobalContex';

const Radio = props => {
  const { setActiveWidgetSettingsParams } = useContext(WidgetsContext);

  const handleToggleChange = (typeParams, e) => {
    let action = { [typeParams.name]: typeParams.value };
    setActiveWidgetSettingsParams(action);
  };

  return (
    <Form.Group className={'mb-3'}>
      <ToggleButtonGroup name="options" className="w-100 mb-3">
        {props.item.variants.map((val, idx) => {
          return (
            <ToggleButton
              key={idx}
              variant={props.value === val ? 'primary' : 'outline-primary'}
              value={val}
              onChange={handleToggleChange.bind(this, { name: props.item.name, value: val })}
              checked={props.value === val}
              id={'radio-' + val}>
              {val}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Form.Group>
  );
};

export default Radio;
